const target = document.querySelector('.collection-hero__filter-container');
const quickLinksNoImages = document.querySelector('#popular--categories-container-1');
const quickLinksWithImages = document.querySelector('#popular--categories-container-2');

if (quickLinksNoImages && !quickLinksWithImages) quickLinksNoImages.classList.add('fade-visible');
if (quickLinksNoImages && quickLinksWithImages) {
  document.addEventListener('scroll', function (el) {
    const quickLinksWithImagesDistanceFromTop = quickLinksWithImages.getBoundingClientRect().top;
    const quickLinksWithImagesHeight = quickLinksWithImages.offsetHeight;
    const showStickyQuickLinksPixels = parseInt(quickLinksWithImagesDistanceFromTop) + parseInt(quickLinksWithImagesHeight);

    if (showStickyQuickLinksPixels < window.scrollY) {
      quickLinksNoImages.classList.add('fade-visible');
    } else {
      quickLinksNoImages.classList.remove('fade-visible');
    }
  });
}

if (target) {
  function mobileFiltersPosition(input) {
    if ((input == 'load' && window.innerWidth < 749) || (input == 'resize' && window.innerWidth < 749)) {
      // Get the DOM nodes
      let element = document.querySelector('.collection-hero__filter-container');
      let target = document.querySelector('#MainContent');
      // Move stuff
      target.prepend(element);
    } else if (input == 'resize' && window.innerWidth >= 749) {
      // Get the DOM nodes
      let element = document.querySelector('.collection-hero__filter-container');
      let target = document.querySelector('#popular--categories-container');
      // Move stuff
      if (target && element) target.after(element);
    }
  }

  window.addEventListener('load', () => {
    mobileFiltersPosition('load');
  });

  window.addEventListener('resize', () => {
    mobileFiltersPosition('resize');
  });
}
